import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DatatableTables from "./DatatableTables"
import MetaTag from "components/Common/Meta-tag"

function ProductPerformance() {
  return (
    <>
      <MetaTag title={"All Performance"} />

      <div className="page-content">
        <Breadcrumbs title="Perfomance" breadcrumbItem="Performance" />
        <Container fluid>
          <div className="container-fluid">
            <DatatableTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default ProductPerformance
